import TidyAvatar1 from '@/assets/tidy_avatar_1.png';
import TidyAvatar2 from '@/assets/tidy_avatar_2.png';
import TidyAvatar3 from '@/assets/tidy_avatar_3.png';
import TidyAvatar4 from '@/assets/tidy_avatar_4.png';
import TidyAvatar5 from '@/assets/tidy_avatar_5.png';

import bitfrost from '@/assets/bitfrost.png';
import Luxtelligence from '@/assets/Luxtelligence.png';
import quintessent from '@/assets/quintessent.png';

export const LOGIN_SALT = '5ac0e45f46654d70bda109477f10c299';

export const Tidy3dBannerItems = [
  {
    content:
      '"Tidy3D easily manages to set up and run complex simulations in a very short time, which not only makes rapid progress in our work but also inspires us to constantly engage ourselves in innovation."',
    name: 'Pritam Bangal',
    introduce:
      'PhD student in Prof. Mohammed Elkabbash’s group at the University of Arizona',
    avatar: TidyAvatar1,
  },
  {
    content:
      '"Tidy3D has significantly improved our workflow with its exceptionally fast simulation processing times and reliable support team. It is an invaluable tool in our research and development of integrated lasers."',
    name: 'Dr. Mohsen Rezaei',
    introduce: 'R&D engineer at FONEX',
    avatar: TidyAvatar2,
  },
  {
    content:
      '“It’s amazing how fast the Flexcompute numerical solver runs. Some simulations that we expect would take days to do, it can do in just 30 minutes. This allows us to simulate many different random configurations, different system sizes, and different structural parameters to see whether we can get three-dimensional localization of light.”',
    name: 'Prof. Hui Cao',
    introduce: 'Yale University',
    avatar: TidyAvatar3,
  },
  {
    content:
      '"Tidy3D allows Ayar Labs to substantially shorten the design cycle of photonic circuits. Excellent agreement between simulation and actual device performance gives the R&D team the confidence to iterate their design entirely on the computer, which substantially improves product performance and reduces the time to market."',
    name: 'Neil Sapra',
    introduce: 'Ayar Labs',
    avatar: TidyAvatar4,
  },
  {
    content:
      '“The Python API and the fast computation speed enabled by the Tidy3D server makes it easier for me to run parameter sweeping and start simulating ideas without the constraint of server time.”',
    name: 'Chaoshen',
    introduce:
      "PhD student in Professor Evelyn Hu's group at Harvard University",
    avatar: TidyAvatar5,
  },
];

export const PhotonForgeBannerItems = [
  {
    content:
      '"We believe that PhotonForge is the right approach to photonic circuit simulations. It allows us to accurately simulate components with the powerful Tidy3D engine and seamlessly integrate them into circuits and layout, using Python code or the GUI."',
    name: 'Miguel Carro Temboury',
    introduce: 'Senior Optical Design Engineer at Bifrost Communications',
    avatar: bitfrost,
  },
  {
    content:
      '"With PhotonForge it\'s extremely simple to define the material stack of any integrated photonics technology, and validating the operation of photonic building blocks or whole circuits is a matter of a few lines of code."',
    name: 'Alberto Beccari',
    introduce: 'Head of Photonic Design at Luxtelligence',
    avatar: Luxtelligence,
  },
  {
    content:
      '“PhotonForge provides us with intuitive integration to Tidy3D, easy scripting and 3D viewing of complex photonic circuits, in addition to robust automation features, such as automatic port detection based on path profiles and automated simulation boundary definitions.”',
    name: 'Szilard Szoke',
    introduce: 'Staff Photonic Design Engineer at Quintessent',
    avatar: quintessent,
  },
];
